export default "__VITE_ASSET__DHATvNFp__"